import React, { useContext } from 'react'
import "./Lahlou.css"
import { RiTwitterFill, RiFacebookFill, RiInstagramLine } from "react-icons/ri";
import { FaUser, FaQuoteLeft, FaQuoteRight, FaBullhorn, FaShieldAlt, FaHandHoldingHeart, FaShareAlt } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { LanguageContext, getTranslation } from "../LanguageContext";

// Objeto de traducciones para el componente Lahlou
const lahlouTranslations = {
  en: {
    title: "President",
    bio: "Azarabe Lahlou, president of the National Association for Child Protection (ANPE), has been actively involved in defending children's rights since the association was founded in 2012. ANPE works to create reception and support structures adapted to children's needs, including protection centers and family guidance services. It also advocates for the establishment of specialized protection mechanisms, such as mobile police units dedicated to combating violence against children.",
    socialMedia: "Social Media",
    connectWithUs: "Connect with us"
  },
  fr: {
    title: "Président",
    bio: "Azarabe Lahlou, président de l'Association nationale de protection de l'enfance (ANPE), s'engage activement dans la défense des droits des enfants depuis la fondation de l'association en 2012. L'ANPE œuvre pour la création de structures d'accueil et de soutien adaptées aux besoins des enfants, incluant des centres de protection et des services d'orientation familiale. Elle plaide également pour l'instauration de dispositifs de protection spécialisés, tels que des unités de police mobiles consacrées à la lutte contre les violences faites aux enfants.",
    socialMedia: "Réseaux Sociaux",
    connectWithUs: "Connectez-vous avec nous"
  },
  ar: {
    title: "الرئيس",
    bio: "يشارك عزرابي لحلو، رئيس الجمعية الوطنية لحماية الطفولة (ANPE)، بنشاط في الدفاع عن حقوق الأطفال منذ تأسيس الجمعية في عام 2012. تعمل ANPE على إنشاء هياكل استقبال ودعم مكيفة مع احتياجات الأطفال، بما في ذلك مراكز الحماية وخدمات التوجيه الأسري. كما تدعو إلى إنشاء آليات حماية متخصصة، مثل وحدات الشرطة المتنقلة المخصصة لمكافحة العنف ضد الأطفال.",
    socialMedia: "وسائل التواصل الاجتماعي",
    connectWithUs: "تواصل معنا"
  }
};

const Lahlou = () => {
  // Usar el contexto de idioma
  const { language } = useContext(LanguageContext);
  
  // Función para obtener la traducción
  const translate = (key) => getTranslation(lahlouTranslations, language, key);
  
  // Determinar si el texto debe fluir de derecha a izquierda (para árabe)
  const isRTL = language === 'ar';
  
  return (
    <div className={`lahlou ${isRTL ? 'rtl' : ''}`}>
      <div className='lahlouOne'>
        <div className='lahlouOne_image'>
          <img src='./image/Lahlou/10.jpg' alt='Lahlou Azarabe' aria-label="President of ANPE" />
          <div className="image-overlay">
            <div className="role-badge">
              <FaShieldAlt className="role-icon" />
              <span>{translate('title')}</span>
            </div>
          </div>
        </div>
      </div>
      <div className='lahlouTwo'>
        <h1>
          <span className="icon-wrapper">
            <FaUser className="president-icon" />
          </span>
          Lahlou Azarabe
          <div className="subtitle">{translate('title')}</div>
        </h1>
        
        <div className="bio-section">
          <div className="bio-heading">
            <FaBullhorn className="bio-icon" />
            <span className="bio-label">ANPE</span>
          </div>
          <p>
            <span className="quote-left">
              <FaQuoteLeft className="quote-icon" />
            </span>
            {translate('bio')}
            <span className="quote-right">
              <FaQuoteRight className="quote-icon" />
            </span>
          </p>
        </div>
        
        <div className="social-section">
          <h3>
            <FaShareAlt className="social-heading-icon" />
            {translate('socialMedia')}
          </h3>
          <p className="connect-text">
            <FaHandHoldingHeart className="connect-icon" />
            {translate('connectWithUs')}
          </p>
          <ul>
            <li>
              <Link to="https://twitter.com/LAHLOU42?t=CtQr8Ve2NtTymx8d5mQXDA&s=09" aria-label="Twitter" target="_blank" rel="noopener noreferrer">
                <RiTwitterFill className="social-icon" />
              </Link>
            </li>
            <li>
              <Link to="https://www.facebook.com/anpe2012?mibextid=ZbWKwL" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                <RiFacebookFill className="social-icon" />
              </Link>
            </li>
            <li>
              <Link to="https://www.instagram.com/lahlouazarabe/?igshid=ZDdkNTZiNTM%3D" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                <RiInstagramLine className="social-icon" />
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Lahlou